var map = {
	"./account_back.png": "6c77",
	"./banner_bottom_2.png": "316e",
	"./banner_bottom_no.png": "9b0b",
	"./banner_top_1.png": "889a",
	"./banner_top_no.png": "03ca",
	"./cover_default_image.png": "27354",
	"./gift-box.png": "d6a9",
	"./left_bottom_5.png": "8ffb",
	"./left_bottom_no.png": "8bd2",
	"./left_center_3.png": "fa2a",
	"./left_center_no.png": "1236",
	"./left_top_1.png": "ebf2",
	"./left_top_no.png": "84f0",
	"./logo.png": "d742",
	"./package_bg_1.png": "1b6f",
	"./package_bg_2.png": "a19c",
	"./package_bg_3.png": "1d43",
	"./right_bottom_6.png": "9cc6",
	"./right_bottom_no.png": "a4e8",
	"./right_center_4.png": "2f44",
	"./right_center_no.png": "ba94",
	"./right_top_2.png": "fffb",
	"./right_top_no.png": "6d73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0f4";